import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatRadioModule } from '@angular/material/radio';

import { RdsDataProductSelectionComponent } from './data-product-selection.component';
import { RdsSortCatalogsPipe } from './sort-catalogs.pipe';

const COMPONENTS = [RdsDataProductSelectionComponent];
const PIPES = [RdsSortCatalogsPipe];

@NgModule({
  imports: [CommonModule, FlexLayoutModule, FormsModule, MatButtonModule, MatDividerModule, MatIconModule, MatListModule, MatRadioModule],
  exports: [COMPONENTS, PIPES],
  declarations: [COMPONENTS, PIPES]
})
export class RdsDataProductSelectionModule {}

export * from './data-product-selection.component';
export * from './sort-catalogs.pipe';
